import React, { Component } from 'react';
import VersionService from '../service/versionService';
import NavigationBar from '../components/navigationBar';

export default class Version extends Component {

    constructor(props) {
        super(props);

        this.versionService = new VersionService();

        this.state = {
            version: {}
        }
    }

    async getVersion() {
        let result = await this.versionService.retrieveBackendVersion();
        this.setState({
            version: result
        });
    }

    componentDidMount() {
        document.title = "Version";
        this.getVersion();
    }

    render() {
        const version = this.state.version;
        if (!version) return null;

        return (
            <div className="body">
                <NavigationBar {...this.props} />
                <main>

                    <center><h1>Version</h1></center>
                    <div>
                        <p>{this.state.version.version}</p>
                    </div>
                </main>
            </div>
        )
    };
}




// WEBPACK FOOTER //
// ./src/sites/version.js